import * as swcHelpers from '@swc/helpers';
import { resilientFetch } from '@grandvisionhq/utils';

const fetch = resilientFetch();
function brHttpClient(options) {
    return _brHttpClient.apply(this, arguments);
}
function _brHttpClient() {
    _brHttpClient = swcHelpers.asyncToGenerator(function*(options) {
        const { url , data  } = options, rest = swcHelpers.objectWithoutProperties(options, [
            "url",
            "data"
        ]);
        const response = yield fetch(url, swcHelpers.objectSpread({}, rest, {
            body: data
        }));
        // Some of the error responses actually contain html instead of json
        // This makes sure we don't actually try to parse html as json
        const contentType = response === null || response === void 0 ? void 0 : response.headers.get('content-type');
        if (!(contentType === null || contentType === void 0 ? void 0 : contentType.includes('application/json'))) {
            throw new Error(`Expected Bloomreach response type to be 'application/json' but got '${contentType}' instead`);
        }
        const json = yield response.json();
        return {
            data: json
        };
    });
    return _brHttpClient.apply(this, arguments);
}

export { brHttpClient };
//# sourceMappingURL=http-client.js.map
